import React, {Component} from "react"
import AvatarEditor from "react-avatar-editor"

import Slider from "../FormItem/Slider"
import Button from "../Button"
import {EditorContainer} from "./styled"

interface OptionalProps {
  onComplete: (image: any) => void
  showSlider: boolean
  buttonText?: string
  landscapeIcon: boolean
  largeBtn?: boolean
  centerSlider?: boolean
}

interface Props extends OptionalProps {
  scale: number
  onUpdate: () => void
}

class ImageEditor extends Component<Props> {
  static defaultProps: OptionalProps = {
    showSlider: true,
    landscapeIcon: false,
    largeBtn: true,
    centerSlider: true,
    onComplete: () => {}
  }

  onComplete = () => {
    const resizedImage = this.getImage()
    this.props.onComplete(resizedImage)
  }

  editorRef = null

  getImage = () => {
    return this.editorRef.getImageScaledToCanvas()
  }

  render() {
    const {scale, landscapeIcon, onUpdate, buttonText, showSlider, largeBtn, centerSlider, ...props} = this.props
    return (
      <>
        <EditorContainer>
          <AvatarEditor
            ref={(el) => {
              this.editorRef = el
            }}
            scale={scale}
            {...props}
          />
        </EditorContainer>
        {showSlider && <Slider landscapeIcon={landscapeIcon} imageScale={scale} onUpdate={onUpdate} centerSlider={centerSlider} />}
        {buttonText && (
          <Button onClick={this.onComplete} primary large={largeBtn}>
            {buttonText}
          </Button>
        )}
      </>
    )
  }
}

export default ImageEditor
